<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import { Helper } from '@/mixin/helper'
import { Export } from '@/mixin/export'
import Layout from '@/router/layouts/main'
import moment from 'moment'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import DetailFleetHistoryTable from './table/DetailFleetHistory'
import DriverManagementTable from './table/DriverManagement'
import FleetHistoryTable from './table/FleetHistory'
import FleetManagementTable from './table/FleetManagement'
import FuelTable from './table/Fuel'
import GeolocationTable from './table/Geolocation'
import DrivingBehaviourTable from './table/DrivingBehaviour'
import SummaryGeolocationTable from './table/SummaryGeolocation'
import SummaryDayTable from './table/SummaryDay.vue'
import SummaryMonthVehicleTable from './table/SummaryMonthVehicle.vue'
import SummaryDayDriverTable from './table/SummaryDayDriver.vue'
import SummaryStoppedTable from './table/SummaryStopped.vue'
import TimeWindowTable from './table/TimeWindow'
import TemperatureTable from './table/Temperature'
import DriverScoreTable from './table/DriverScore'
import SummaryVehicleOutsideGeofenceTable from './table/SummaryVehicleOutsideGeofence'
import DoorTable from './table/Door'
import WorkingHoursTable from './table/WorkingHours'
import DownloadLoadingFloat from '@/components/loading-float.vue'
import { GET_DOWNLOAD_HISTORIES } from '@/services/api/report/report'
import ModalFilterReport from '@/components/Modals/ModalFilterReport'
import DailyVehicleTable from './table/DailyVehicle'
import ExcessiveIdleTable from './table/ExcessiveIdle.vue'
import EstimationFuelUsageTable from './table/EstimationFuelUsage'
import i18n from '../../../i18n'

moment.locale('id')

/**
 * Starter component
 */
export default {
  page: {
    title: 'Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Multiselect,
    DatePicker,
    Layout,
    PageHeader,
    FuelTable,
    FleetHistoryTable,
    GeolocationTable,
    DrivingBehaviourTable,
    WorkingHoursTable,
    TimeWindowTable,
    FleetManagementTable,
    DriverManagementTable,
    DetailFleetHistoryTable,
    SummaryDayTable,
    SummaryMonthVehicleTable,
    SummaryDayDriverTable,
    SummaryStoppedTable,
    DownloadLoadingFloat,
    SummaryGeolocationTable,
    DoorTable,
    TemperatureTable,
    ModalFilterReport,
    DailyVehicleTable,
    DriverScoreTable,
    SummaryVehicleOutsideGeofenceTable,
    ExcessiveIdleTable,
    EstimationFuelUsageTable
  },
  mixins: [Export, Helper],
  apollo: {
    downloadHistory: {
      query: GET_DOWNLOAD_HISTORIES,
      variables() {
        return {
          filter: {
            orderBy: [JSON.stringify({ downloadOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.initDownloadHistory(data)
        }
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      listSelect: [],
      employees: {
        employees: [],
      },
      vehicles: {
        vehicles: [],
      },
      filter: null,
      search: {
        fleet: null,
        driver: null,
        vehicle: null,
      },

      tableData: [
        {
          licensePlat: 'L 1234 LL',
          fleetType: 'Flat Desk STD',
        },
        {
          licensePlat: 'L 56 LL',
          fleetType: 'Zx',
        },
        {
          licensePlat: 'L 789 LL',
          fleetType: 'OP',
        },
      ],

      totalTrue() {
        return this.selectedModel.fields.filter((c) => c === true)
      },

      fieldsDriver: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'fullname',
          label: 'Pengemudi',
          sortable: false,
        },
      ],

      fieldsVehicle: [
        {
          key: 'columnCheck',
          label: '',
          sortable: false,
          thClass: 'mc-table--30',
        },
        {
          key: 'licensePlate',
          label: 'Plat Nomor',
          sortable: false,
        },
        {
          key: 'vehicleTypeName',
          label: 'Jenis Kendaraan',
          sortable: false,
        },
      ],

      fieldsManagementDriver: [
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 30,
        },
        {
          key: 'totalDistance',
          label: 'Total Jarak Tempuh (Km)',
          header: 'total_distance',
          filter: false,
          width: 20,
        },
        {
          key: 'totalTimeTrip',
          label: 'Total Waktu Perjalanan',
          header: 'total_time_trip',
          filter: false,
          width: 20,
        },
        {
          key: 'totalTimeTripStop',
          label: 'Total Waktu Berhenti',
          header: 'total_time_trip_stop',
          filter: false,
          width: 20,
        },
      ],
      fieldsManagementVehicle: [
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'totalMoving',
          label: 'Jarak Berjalan (Km)',
          header: 'total_moving',
          filter: false,
          width: 10,
        },
        {
          key: 'totalAssisted',
          label: 'Jarak Dibantu (Km)',
          header: 'total_assisted',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourMovingFormatted',
          label: 'Durasi Berjalan',
          header: 'total_hour_moving',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourAssistedFormatted',
          label: 'Durasi Dibantu',
          header: 'total_hour_assisted',
          filter: false,
          width: 10,
        },
        {
          key: 'totalTimeTripStopFormatted',
          label: 'Total Durasi Berhenti',
          header: 'total_hour_trip_stop',
          filter: false,
          width: 10,
        },
        // {
        //   key: "fuelEficiency",
        //   label: "Efisiensi Bahan Bakar (Km/L)",
        //   header: "fuel_eficiency",
        //   filter: false,
        //   width: 10,
        // },
        // {
        //   key: "totalEficiency",
        //   label: "Total Efisiensi Bahan Bakar (L)",
        //   header: "total_eficiency",
        //   filter: false,
        //   width: 10,
        // },
        {
          key: 'averageSpeed',
          label: 'Kecepatan Rata-Rata (Km/Jam)',
          header: 'average_speed',
          filter: false,
          width: 10,
        },
      ],
      fieldsHistoryVehicle: [
        {
          key: 'startTime',
          label: 'Tanggal Awal',
          header: 'start_date',
          filter: false,
          disabled: true,
          width: 20,
        },
        {
          key: 'stopTime',
          label: 'Tanggal Akhir',
          header: 'end_date',
          filter: false,
          disabled: true,
          width: 20,
        },
        {
          key: 'driver',
          label: 'Pengemudi Utama',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'startLocation',
          label: 'Lokasi Mulai',
          header: 'start_address',
          filter: false,
          width: 30,
        },
        {
          key: 'endLocation',
          label: 'Lokasi Berhenti',
          header: 'end_address',
          filter: false,
          width: 30,
        },
        {
          key: 'tripMileage',
          label: 'Total Jarak Tempuh (Km)',
          header: 'trip_mileage',
          filter: false,
          width: 10,
        },
        {
          key: 'totalTimeTrip',
          label: 'Total Waktu Perjalanan',
          header: 'total_time_trip',
          filter: false,
          width: 10,
        },
        {
          key: 'eficiency',
          label: 'Efisiensi Bahan Bakar (Km/L)',
          header: 'eficiency',
          filter: false,
          width: 10,
        },
        {
          key: 'averageSpeed',
          label: 'Kecepatan Rata-Rata (Km/Jam)',
          header: 'averageSpeed',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourStop',
          label: 'Total Waktu Berhenti',
          header: 'total_hour_stop',
          filter: false,
          width: 10,
        },
      ],
      fieldsDetailHistoryVehicle: [
        {
          key: 'sentOn',
          label: 'Tanggal',
          header: 'date',
          disabled: true,
          filter: false,
          width: 30,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'driver',
          label: 'Pengemudi Utama',
          header: 'driver',
          filter: false,
          width: 20,
        },
        {
          key: 'latitude',
          label: 'Garis Lintang',
          header: 'latitude',
          filter: false,
          width: 30,
        },
        {
          key: 'longitude',
          label: 'Garis Bujur',
          header: 'longitude',
          filter: false,
          width: 30,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 30,
        },
        {
          key: 'speed',
          label: 'Kecepatan Km/Jam',
          header: 'speed',
          filter: false,
          width: 10,
        },
      ],

      fieldsSummaryDay: [
        {
          key: 'day',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'totalMoving',
          label: 'Jarak Berjalan (Km)',
          header: 'total_moving',
          filter: false,
          width: 10,
        },
        {
          key: 'totalAssisted',
          label: 'Jarak Dibantu (Km)',
          header: 'total_assisted',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourMovingFormatted',
          label: 'Durasi Berjalan',
          header: 'total_hour_moving',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourAssistedFormatted',
          label: 'Durasi Dibantu',
          header: 'total_hour_assisted',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourTripStopFormatted',
          label: 'Total Durasi Berhenti',
          header: 'total_hour_trip_stop',
          filter: false,
          width: 10,
        },
      ],
      fieldsSummaryMonthVehicle: [
        {
          key: 'licensePlate',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 40,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'area',
          label: 'Area/Hub Kendaraan',
          header: 'area',
          filter: false,
          width: 30,
        },
        {
          key: 'distance',
          label: 'Jarak (Km)',
          header: 'distance',
          filter: false,
          width: 10,
        },
        {
          key: 'workDays',
          label: 'Total Hari Kerja',
          header: 'work_days',
          filter: false,
          width: 10,
        },
        {
          key: 'workHours',
          label: 'Total Jam Kerja',
          header: 'work_hours',
          filter: false,
          width: 10,
        },
        {
          key: 'workHoursAvg',
          label: 'Rata-Rata Jam Kerja',
          header: 'work_hours_avg',
          filter: false,
          width: 10,
        },
        {
          key: 'parkingHours',
          label: 'Durasi Parkir',
          header: 'parking_hours',
          filter: false,
          width: 10,
        },
        {
          key: 'movingWorkHours',
          label: 'Durasi Berjalan',
          header: 'moving_work_hours',
          filter: false,
          width: 10,
        },
        {
          key: 'movingHours',
          label: 'Durasi Berpindah',
          header: 'moving_hours',
          filter: false,
          width: 10,
        }
      ],
      fieldsSummaryDayDriver: [
        {
          key: 'day',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'totalDistance',
          label: 'Total Jarak Tempuh (Km)',
          header: 'total_distance',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourTrip',
          label: 'Total Waktu Perjalanan',
          header: 'total_hour_trip',
          filter: false,
          width: 10,
        },
        {
          key: 'totalHourTripStop',
          label: 'Total Waktu Berhenti',
          header: 'total_hour_trip_stop',
          filter: false,
          width: 10,
        },
      ],

      fieldsSummaryStopped: [
        {
          key: 'startTime',
          label: 'Tanggal Awal',
          header: 'start_date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'stopTime',
          label: 'Tanggal Akhir',
          header: 'end_date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
        },
        {
          key: 'timeStopFormatted',
          label: 'Total Waktu Berhenti',
          header: 'time_stop_formatted',
          filter: false,
          width: 10,
        },
      ],

      fieldsGeolocation: [
        {
          key: 'transitOn',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'geofence',
          label: 'Geolokasi',
          header: 'geofence',
          filter: true,
          width: 10,
        },
      ],

      fieldsSummaryGeolocation: [
        {
          key: 'outTime',
          label: 'Tanggal Keluar',
          header: 'out_time',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'inTime',
          label: 'Tanggal Masuk',
          header: 'in_time',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: false,
          width: 20,
        },
        {
          key: 'geofence',
          label: 'Geolokasi',
          header: 'geofence',
          filter: true,
          width: 10,
        },
        {
          key: 'duration',
          label: 'Durasi',
          header: 'duration',
          filter: false,
          width: 10,
        },
      ],

      fieldsDoor: [
        {
          key: 'doorOpenedOn',
          label: 'Waktu Pintu Terbuka',
          header: 'door_opened_on',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'doorClosedOn',
          label: 'Waktu Pintu Tertutup',
          header: 'door_closed_on',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
        },
        {
          key: 'doorSensor',
          label: 'Sensor Pintu',
          header: 'door_sensor',
          filter: false,
          width: 10,
        },
        {
          key: 'duration',
          label: 'Durasi Pintu Terbuka',
          header: 'duration_open_door',
          filter: false,
          width: 10,
        },
      ],

      fieldsTemperature: [
        {
          key: 'createdOn',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'temperature',
          label: 'Sensor Suhu 1 (°C)',
          header: 'temperature',
          filter: false,
          width: 10,
        },
        {
          key: 'door1',
          label: 'Sensor Pintu 1',
          header: 'door1',
          filter: false,
          width: 10,
          disabled: false,
        },
        {
          key: 'door2',
          label: 'Sensor Pintu 2',
          header: 'door2',
          filter: false,
          width: 10,
          disabled: false,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
        },
      ],

      fieldsFuel: [
        {
          key: 'createdOn',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'fuel',
          label: 'Bahan Bakar (L)',
          header: 'fuel',
          filter: false,
          width: 10,
        },
        {
          key: 'fuelPercentage',
          label: 'Bahan Bakar (%)',
          header: 'fuel_percentage',
          filter: false,
          width: 10,
          disabled: false,
        },
        {
          key: 'speed',
          label: 'Kecepatan (Km/Jam)',
          header: 'speed',
          filter: false,
          width: 10,
          disabled: false,
          formatter: (value) => {
            return value ? value : 0
          },
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
          formatter: (value) => {
            return value ? value : '-'
          },
        },
      ],

      fieldsTimeWindow: [
        {
          key: 'fenceName',
          label: 'Nama Lokasi',
          header: 'fence_name',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'transitOn',
          label: 'Waktu Masuk Geolokasi',
          header: 'time_in_geo',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'doorOpen',
          label: 'Waktu Pintu Terbuka',
          header: 'time_door_open',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'doorClose',
          label: 'Waktu Pintu Tertutup',
          header: 'time_door_close',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'transitOnOut',
          label: 'Waktu Keluar Geolokasi',
          header: 'time_out_geo',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
          disabled: true,
        },
        {
          key: 'geofence',
          label: 'Garasi',
          header: 'geofence',
          filter: true,
          width: 20,
          disabled: true,
        },
        {
          key: 'timeInQueue',
          label: 'Durasi Masuk Antrian',
          header: 'time_in_queue',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'timeLoading',
          label: 'Durasi Bongkar/Muat',
          header: 'time_loading',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'timeOutQueue',
          label: 'Durasi Keluar Antrian',
          header: 'time_out_queue',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'timeInGeofence',
          label: 'Durasi Dalam Geolokasi',
          header: 'time_inside_geo',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'timeBetweenGeofence',
          label: 'Durasi Antar Geolokasi',
          header: 'time_between_geo',
          filter: false,
          width: 20,
          disabled: true,
        },
      ],
      fieldsDrivingBehaviour: [
      {
          key: 'createdOn',
          label: 'Tanggal',
          header: 'date',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'alert',
          label: 'Jenis Peringatan',
          header: 'alert',
          filter: false,
          width: 20,
        },
        {
          key: 'alertData',
          label: 'Kecepatan',
          header: 'alert_data',
          filter: false,
          width: 10,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
        },
      ],
      fieldsDailyVehicle: [
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'vehicleHub',
          label: 'Area/Hub Kendaraan',
          header: 'vehicle_hub',
          filter: false,
          width: 30,
        },
        {
          key: 'startTime',
          label: 'Waktu Mulai',
          header: 'start_date',
          filter: false,
          disabled: true,
          width: 30,
        },
        {
          key: 'stopTime',
          label: 'Waktu Berhenti',
          header: 'end_date',
          filter: false,
          disabled: true,
          width: 30,
        },
        {
          key: 'startLocation',
          label: 'Lokasi Mulai',
          header: 'start_address',
          filter: false,
          width: 30,
        },
        {
          key: 'endLocation',
          label: 'Lokasi Berhenti',
          header: 'end_address',
          filter: false,
          width: 30,
        },
        {
          key: 'tripMileage',
          label: 'Jarak (Km)',
          header: 'trip_mileage',
          filter: false,
          width: 10,
        },
        {
          key: 'totalTimeTrip',
          label: 'Durasi (Jam)',
          header: 'total_time_trip',
          filter: false,
          width: 10,
        }
      ],

      fieldsDriverScore: [
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'totalHours',
          label: 'Durasi Bekerja',
          header: 'total_hours',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'totalDriven',
          label: 'Total Jarak Tempuh (Km)',
          header: 'total_driven',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'driverViolation',
          label: 'Pelanggaran Pengemudi',
          filter: false,
          disabled: true,
          width: 30,
          children: [
            {
              key: 'overspeeds',
              label: 'Kecepatan Melebihi Batas Aman',
              header: 'column_overspeed',
              headerColspan: 1,
            },
            {
              key: 'harshAccels',
              label: 'Akselerasi Mendadak',
              header: 'column_harshAccels',
              headerColspan: 1,
            },
            {
              key: 'harshBrakes',
              label: 'Perlambatan Mendadak',
              header: 'column_harshBrakes',
              headerColspan: 1,
            },
            {
              key: 'sharpTurns',
              label: 'Tikungan Tajam',
              header: 'column_sharpTurns',
              headerColspan: 1,
            },
            {
              key: 'finalGrade',
              label: 'Index',
              header: 'column_finalGrade',
              headerColspan: 1,
            },
          ],
          headerColspan: 5,
        },
        {
          key: 'deliveryViolation',
          label: 'Pelanggaran Pengiriman',
          filter: false,
          disabled: true,
          width: 30,
          children: [
            {
              key: 'restViolation',
              label: 'Pelanggaran Istirahat',
              header: 'column_restViolation',
              headerColspan: 1,
            },
            {
              key: 'drivingViolation',
              label: 'Pelanggaran Mengemudi',
              header: 'column_drivingViolation',
              headerColspan: 1,
            },
            {
              key: 'idleViolation',
              label: 'Pelanggaran Diam',
              header: 'column_idleViolation',
              headerColspan: 1,
            }
          ],
          headerColspan: 3,
        },
      ],

      fieldsSummaryVehicleOutsideGeolocation: [
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'licensePlate',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'geofence',
          label: 'Geolokasi',
          header: 'geofence',
          filter: true,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'duration',
          label: 'Duration',
          header: 'duration',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'outTime',
          label: 'Tanggal Keluar',
          header: 'out_time',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'inTime',
          label: 'Tanggal Masuk',
          header: 'in_time',
          filter: false,
          width: 20,
          headerRowspan: 2,
        },
        {
          key: 'visitedGeofence',
          label: 'Mengunjungi Geolokasi',
          header: 'visited_geofence',
          filter: false,
          width: 40,
          headerRowspan: 2,
        }
      ],

      fieldsExcessiveIdle: [
        {
          key: 'startTime',
          label: 'Waktu Mulai',
          header: 'start_time',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'stopTime',
          label: 'Waktu Berhenti',
          header: 'stop_time',
          filter: false,
          width: 20,
          disabled: true,
        },
        {
          key: 'vehicleType',
          label: 'Jenis Kendaraan',
          header: 'vehicle_type',
          filter: false,
          width: 30,
        },
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'acc',
          label: 'ACC',
          header: 'acc',
          filter: false,
          width: 10 
        },
        {
          key: 'driver',
          label: 'Pengemudi',
          header: 'driver',
          filter: true,
          width: 20,
        },
        {
          key: 'timeStopFormatted',
          label: 'Total Durasi Diam',
          header: 'time_stop_formatted',
          filter: false,
          width: 10,
        },
        {
          key: 'address',
          label: 'Lokasi',
          header: 'address',
          filter: false,
          width: 10,
        },
      ],

      fieldsEstimationFuelUsage: [
        {
          key: 'vehicle',
          label: 'Plat Nomor',
          header: 'license_plate',
          filter: true,
          width: 20,
        },
        {
          key: 'startTime',
          label: 'Tanggal',
          header: 'start_time',
          filter: false,
          width: 20
        },
        {
          key: 'acc',
          label: 'ACC',
          header: 'acc',
          filter: false,
          width: 10 
        },
        {
          key: 'startAddress',
          label: 'Lokasi Mulai',
          header: 'start_address',
          filter: false,
          width: 10,
        },
        {
          key: 'endAddress',
          label: 'Lokasi Berhenti',
          header: 'end_address',
          filter: false,
          width: 10,
        },
        {
          key: 'ratio',
          label: 'Rasio',
          header: 'ratio',
          filter: false,
          width: 10,
        },
        {
          key: 'tripMileage',
          label: 'Total Jarak Tempuh (Km)',
          header: 'trip_mileage',
          filter: false,
          width: 10,
        },
        {
          key: 'fuelUsage',
          label: 'Penggunaan Bahan Bakar (L)',
          header: 'fuel_usage',
          filter: false,
          width: 10,
        },
      ],

      filterManagementDriver: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterManagementVehicle: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterHistoryVehicle: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterDetailHistoryVehicle: {
        fields: [],
        filterVehicle: [],
      },
      filterSummaryDay: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterSummaryMonthVehicle: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterSummaryDayDriver: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterSummaryStopped: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterGeolocation: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
        filterGeofence: [],
      },
      filterSummaryGeolocation: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
        filterGeofence: [],
      },
      filterAlert: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
        filterAlert: [],
      },
      filterDoor: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterTemperature: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterFuel: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterTimeWindow: {
        fields: [],
        filterGeofence: [],
        filterVehicle: [],
      },
      filterDrivingBehaviour: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterDailyVehicle: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterDriverScore: {
        fields: [],
        filterDriver: [],
        filterGrade: [],
      },
      filterSummaryVehicleOutsideGeolocation: {
        fields: [],
        filterGeofence: 0,
        filterVehicle: [],
      },
      filterExcessiveIdle: {
        fields: [],
        filterDriver: [],
        filterVehicle: [],
      },
      filterEstimationFuelUsage: {
        fields: [],
        filterVehicle: [],
      },

      isAddFavorit: false,
      addFavorit: null,

      report: '',
      reportOptions: [
        {
          key: 'fuel',
          label: 'Bahan Bakar',
          modal: 'bahan-bakar',
          table: 'fuelRef',
        },
        {
          key: 'detail-history-vehicle',
          label: 'Detail Riwayat Kendaraan',
          modal: 'detail-riwayat-kendaraan',
          table: 'detailHistoryVehicleRef',
        },
        {
          key: 'geolocation',
          label: 'Geolokasi',
          modal: 'geolokasi',
          table: 'geolocationRef',
        },
        {
          key: 'management-vehicle',
          label: 'Manajemen Kendaraan',
          modal: 'manajemen-kendaraan',
          table: 'managementVehicleRef',
        },
        {
          key: 'management-driver',
          label: 'Manajemen Pengemudi',
          modal: 'manajemen-pengemudi',
          table: 'managementDriverRef',
        },
        { key: 'door', 
          label: 'Pintu', 
          modal: 'pintu', 
          table: 'doorRef' 
        },
        {
          key: 'summary-geolocation',
          label: 'Ringkasan Geolokasi',
          modal: 'ringkasan-geolokasi',
          table: 'summaryGeolocationRef',
        },
        {
          key: 'history-vehicle',
          label: 'Riwayat Kendaraan',
          modal: 'riwayat-kendaraan',
          table: 'historyVehicleRef',
        },
        // ! this report has been hiding
        // {
        //   key: 'temperature',
        //   label: 'Temperatur',
        //   modal: 'temperatur',
        //   table: 'temperatureRef',
        // },
        {
          key: 'summary-day',
          label: 'Ringkasan Harian Kendaraan',
          modal: 'ringkasan-harian-kendaraan',
          table: 'summaryDayRef',
        },
        {
          key: 'summary-month-vehicle',
          label: 'Pemantauan Bulanan Kendaraan',
          modal: 'pemantauan-bulanan-kendaraan',
          table: 'summaryMonthVehicleRef',
        },
        {
          key: 'summary-day-driver',
          label: 'Ringkasan Harian Pengemudi',
          modal: 'ringkasan-harian-pengemudi',
          table: 'summaryDayDriverRef',
        },
        {
          key: 'summary-stopped',
          label: 'Waktu Berhenti',
          modal: 'waktu-berhenti',
          table: 'summaryStoppedRef',
        },
        {
          key: 'time-window',
          label: 'Jendela Waktu',
          modal: 'jendela-waktu',
          table: 'timeWindowRef',
        },
        {
          key: 'driving-behaviour',
          label: 'Perilaku Mengemudi',
          modal: 'excessive-driving-behaviour',
          table: 'drivingBehaviourRef',
        },
        {
          key: 'daily-vehicle',
          label: 'Pemantauan Harian Kendaraan',
          modal: 'pemantauan-harian-kendaraan',
          table: 'dailyVehicleMonitoringRef',
        },
        {
          key: 'driver-score',
          label: 'Penilaian Pengemudi',
          modal: 'penilaian-pengemudi',
          table: 'driverScoreRef',
        },
        {
          key: 'summary-vehicle-outside-geolocation',
          label: 'Ringkasan Kendaraan Keluar Geolokasi',
          modal: 'ringkasan-kendaraan-keluar-geolokasi',
          table: 'summaryVehicleOutsideGeolocationRef',
        },
        {
          key: 'excessive-idle',
          label: 'Kendaraan Diam Berlebihan',
          modal: 'kendaraan-diam-berlebihan',
          table: 'excessiveIdleRef',
        },
        {
          key: 'estimation-fuel-usage',
          label: 'Penggunaan Bahan Bakar (Tanpa Sensor)',
          modal: 'penggunaan-bahan-bakar-(tanpa-sensor)',
          table: 'estimationFuelUsageRef',
        },
      ],
      favorit: '',
      favoritOptions: ['Standar', 'Kendaraan Saja', 'Pengemudi Saja'],
      interval: {
        key: 1,
        label: '1 Menit',
      },
      intervalOptions: [
        { key: 1, label: '1 Menit' },
        { key: 2, label: '2 Menit' },
        { key: 5, label: '5 Menit' },
        { key: 10, label: '10 Menit' },
      ],
      periode: null,
      periodeMonth: null,
      monthNameFilter: '',
      monthFilter: '',
      yearFilter: '',
      OrderTable: [
        'Tanggal',
        'Plat Nomor',
        'Jenis Kendaraan',
        'Pengemudi Utama',
        'Pengemudi Cadangan',
        'Garis Lintang',
        'Garis Bujur',
        'Lokasi',
        'Kecepatan (Km/Jam)',
      ],

      historyFields: [
        {
          key: 'title',
          label: 'Judul Laporan',
        },
        {
          key: 'periode',
          label: 'Periode Laporan',
        },
        {
          key: 'downloadOn',
          label: 'Tanggal Unduh',
        },
        {
          key: 'typeCode',
          label: 'Jenis',
        },
        {
          key: 'action',
          label: '',
        },
      ],
      historyItems: [
        {
          id: 1,
          judul_laporan: 'Detail Riwayat Kendaraan',
          periode: '05 Mei 2022 07:02 - 30 Mei 2022 07:02',
          tanggal_unduh: '31 Mei 2022',
          jenis: 'Tabel',
        },
      ],
      historyCurrentPage: 1,
      historyTotalRows: 1,
      historyPerPage: 10,
      historyPageOption: [10, 25, 50, 100],
      historyFilteredItems: [],
      downloadHistories: [],
      isHistoriesLoading: false,
      historyFilter: null,

      reportPreview: false,

      openTableView: false,
      isFilterHistoryVehicleOpen: false,
      isFilterDetailHistoryVehicleOpen: false,
      isMonth: true,
      pastDate: moment().subtract(1, 'years'),
      futureEnd: moment().add(1, 'years'),
      startDate: null,
      endDate: null,
      delay: null,
      numPlate: null,
    }
  },

  computed: {
    /**
     * Total no. of records
     */

    title() {
      return this.$t('menuitems.laporan.text')
    },

    items() {
      return [
        {
          text: this.$t('menuitems.laporan.text'),
        },
      ]
    },

    makeShortcuts() {
      if (this.report.key == 'detail-history-vehicle') {
        return [
          { text: 'Hari Ini', onClick: () => [new Date(), new Date()] },
          {
            text: 'Kemarin',
            onClick: () => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              return [date, new Date()]
            },
          },
          {
            text: '3 Hari Terakhir',
            onClick: () => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 72)
              return [date, new Date()]
            },
          },
        ]
      }

      const shortcuts = [
        { text: 'Hari Ini', onClick: () => [new Date(), new Date()] },
        {
          text: 'Kemarin',
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, new Date()]
          },
        },
        {
          text: '7 Hari Terakhir',
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 168)
            return [date, new Date()]
          },
        },
      ]

      const last_thirty_one_days_report =[
        'excessive-idle',
        'management-vehicle',
        'management-driver',
      ]
      if (last_thirty_one_days_report.includes(this.report.key)){
        shortcuts.push({
          text: '31 Hari Terakhir',
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 720)
            return [date, new Date()]
          },
        })
      }

      return shortcuts
    },

    errorDownloadHistories() {
      return this.downloadHistories.filter((item) => item.status == 'F')
    },

    listDownloadHistories() {
      return this.downloadHistories.filter((item) => item.status != 'F' && item.status != 'I')
    },

    isGraphOpen() {
      if (this.$refs.temperatureRef === undefined) return false

      return this.$refs.temperatureRef.showGraph
    },
  },

  // filters: {
  // 	moment: function (date) {
  //     if(this.report.label === 'Detail Riwayat Kendaraan' || this.report.label === 'Riwayat Kendaraan'){
  //       return moment(date).format("DD MMMM YYYY HH:mm:ss");
  //     }else {
  //       return moment(date).format("DD MMMM YYYY");
  //     }
  // 	},
  // },

  watch: {
    '$i18n.locale': function () {
      this.getFields()

      this.refresh = false

      setTimeout(() => {
        this.refresh = true
        if (this.report) {
          const filterLabel = this.reportOptionFlag.filter((x) => x.key === this.report.key)
          this.report.label = filterLabel[0].label
        }
        if (this.clicked) {
          setTimeout(() => {
            this.getPreviewReport()
          }, 100)
        }
      }, 500)
    },
  },

  created() {
    this.getFields()
    i18n.locale = localStorage.getItem('language')

  },

  methods: {
    getFields() {
      this.filterManagementDriver.fields = this.fieldsManagementDriver
      this.filterManagementVehicle.fields = this.fieldsManagementVehicle
      this.filterHistoryVehicle.fields = this.fieldsHistoryVehicle
      this.filterDetailHistoryVehicle.fields = this.fieldsDetailHistoryVehicle
      this.filterSummaryDay.fields = this.fieldsSummaryDay
      this.filterSummaryMonthVehicle.fields = this.fieldsSummaryMonthVehicle
      this.filterSummaryDayDriver.fields = this.fieldsSummaryDayDriver
      this.filterSummaryStopped.fields = this.fieldsSummaryStopped
      this.filterGeolocation.fields = this.fieldsGeolocation
      this.filterSummaryGeolocation.fields = this.fieldsSummaryGeolocation
      this.filterDoor.fields = this.fieldsDoor
      this.filterTemperature.fields = this.fieldsTemperature
      this.filterFuel.fields = this.fieldsFuel
      this.filterTimeWindow.fields = this.fieldsTimeWindow
      this.filterDrivingBehaviour.fields = this.fieldsDrivingBehaviour
      this.filterDriverScore.fields = this.fieldsDriverScore
      this.filterSummaryVehicleOutsideGeolocation.fields = this.fieldsSummaryVehicleOutsideGeolocation
      this.filterDailyVehicle.fields = this.fieldsDailyVehicle
    },

    updateCheckall() {
      let obj = { ...this.modalModelLaporan }
      let falseParam = []
      Object.keys(obj).forEach(function (key) {
        if (key !== 'all') {
          if (!obj[key]) {
            falseParam.push(obj[key])
          }
        }
      })

      if (falseParam.length !== 0) {
        this.modalModelLaporan.all = false
      }
    },

    initDownloadHistory(data) {
      var self = this
      self.downloadHistories = data.downloadHistory.downloadHistory
      self.historyFilteredItems = data.downloadHistory.downloadHistory
      self.historyTotalRows = data.downloadHistory.downloadHistory.length
    },
    refreshDownloadHistory() {
      this.$apollo.queries.downloadHistory.refetch()
    },
    toDownloadHistory() {
      var self = this
      this.$apollo.queries.downloadHistory.refetch()
      self.$bvModal.show('download-history-report')
    },
    onFilteredHistory(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.historyFilteredItems = filteredItems
      this.historyTotalRows = filteredItems.length
      this.historyCurrentPage = 1
    },

    getPreviewReport() {
      const validationPeriode = [
        'Pemantauan Bulanan Kendaraan',
        'Penilaian Pengemudi',
      ]
      if (((validationPeriode.includes(this.report.label)) && !this.periodeMonth) || (!validationPeriode.includes(this.report.label) && (!this.periode || !this.periode[0] || !this.periode[1]))) {
        return Swal.fire({
          title: 'Gagal Pratinjau',
          text: 'Anda diharuskan memilih periode laporan terlebih dahulu.',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          confirmButtonText: 'Tutup',
        })
      }

      var args = this.generateFilter()
      if (args.length == 0) {
        return
      }

      if (this.report.label === 'Bahan Bakar') {
        this.numPlate = this.filterFuel.filterVehicle.licensePlate
      }
      if (this.report.label === 'Temperatur') {
        this.numPlate = this.filterTemperature.filterVehicle.licensePlate
      }
      if (
        this.report.label === 'Detail Riwayat Kendaraan' ||
        this.report.label === 'Riwayat Kendaraan' ||
        this.report.label === 'Bahan Bakar'
      ) {
        this.startDate = this.momentDMYHS(this.periode[0])
        this.endDate = this.momentDMYHS(this.periode[1])
      }
      else if (this.report.label === 'Pemantauan Bulanan Kendaraan' || this.report.label === 'Penilaian Pengemudi') {
        let splittedPeriod = this.periodeMonth
        if (typeof splittedPeriod == 'string' || splittedPeriod instanceof String) {
          splittedPeriod = splittedPeriod.split('-')
        }
        this.startDate = Number(splittedPeriod[0]) // Tahun
        this.endDate = Number(splittedPeriod[1]) // Bulan
        this.monthNameFilter = moment().month(this.endDate - 1).format('MMMM')
      }
      else {
        this.startDate = this.momentDateLongMonth(this.periode[0])
        this.endDate = this.momentDateLongMonth(this.periode[1])
      }

      this.delay = this.interval.label

      return this.refreshState(this.$refs[this.report.table], ...args)
    },

    generateFilter() {
      var args = []
      switch (this.report.key) {
        case 'detail-history-vehicle':
          if (
            this.filterDetailHistoryVehicle.filterVehicle.length == 0
          ) {
            this.alertFilter('both')
            return []
          }
          args = [
            this.filterDetailHistoryVehicle.filterVehicle,
            this.interval,
            this.filterDetailHistoryVehicle.fields,
          ]
          break
        case 'geolocation':
          args = [
            this.filterGeolocation.filterVehicle,
            this.filterGeolocation.filterDriver,
            this.filterGeolocation.filterGeofence,
            this.filterGeolocation.fields,
          ]
          break
        case 'management-vehicle':
          args = [this.filterManagementVehicle.filterVehicle, this.filterManagementVehicle.fields]
          break
        case 'management-driver':
          args = [this.filterManagementDriver.filterDriver, this.filterManagementDriver.fields]
          break
        case 'alert':
          if (this.filterAlert.filterVehicle.length == 0) {
            this.alertFilter('vehicle')
            return []
          }
          args = [
            this.filterAlert.filterVehicle,
            this.filterAlert.filterDriver,
            this.filterAlert.filterAlert,
            this.filterAlert.fields,
          ]
          break
        case 'door':
          if (this.filterDoor.filterVehicle.length == 0) {
            this.alertFilter('vehicle')
            return []
          }
          args = [
            this.filterDoor.filterVehicle,
            this.filterDoor.filterDriver,
            this.filterDoor.fields,
          ]
          break
        case 'summary-geolocation':
          args = [
            this.filterSummaryGeolocation.filterVehicle,
            this.filterSummaryGeolocation.filterDriver,
            this.filterSummaryGeolocation.filterGeofence,
            this.filterSummaryGeolocation.fields,
          ]
          break
        case 'history-vehicle':
          args = [
            this.filterHistoryVehicle.filterVehicle,
            this.filterHistoryVehicle.filterDriver,
            this.filterHistoryVehicle.fields,
          ]
          break
        case 'summary-day':
          args = [this.filterSummaryDay.filterVehicle, this.filterSummaryDay.fields]
          break
        case 'summary-month-vehicle':
          args = [this.filterSummaryMonthVehicle.filterVehicle, this.filterSummaryMonthVehicle.fields]
          break
        case 'summary-day-driver':
          if (
            this.report.key == 'summary-day-driver' &&
            this.filterSummaryDayDriver.filterDriver.length == 0
          ) {
            this.alertFilter('driver')
            return []
          }
          args = [this.filterSummaryDayDriver.filterDriver, this.filterSummaryDayDriver.fields]
          break
        case 'summary-stopped':
          if (
            this.report.key == 'summary-stopped' &&
            this.filterSummaryStopped.filterVehicle.length == 0 &&
            this.filterSummaryStopped.filterDriver.length == 0
          ) {
            this.alertFilter('both')
            return []
          }
          args = [
            this.filterSummaryStopped.filterVehicle,
            this.filterSummaryStopped.filterDriver,
            this.filterSummaryStopped.fields,
          ]
          break
        case 'temperature':
          if (this.filterTemperature.filterVehicle.length == 0) {
            this.alertFilter('vehicle')
            return []
          }
          args = [this.filterTemperature.filterVehicle, this.filterTemperature.fields]
          break
        case 'fuel':
          if (this.filterFuel.filterVehicle.length == 0) {
            this.alertFilter('vehicle')
            return []
          }
          args = [this.filterFuel.filterVehicle, this.interval, this.filterFuel.fields]
          break
        case 'time-window':
          if (
            this.filterTimeWindow.filterVehicle.length == 0 ||
            this.filterTimeWindow.filterGeofence.length == 0
          ) {
            this.alertFilter('vehicle_garage')
            return []
          }
          args = [
            this.filterTimeWindow.filterVehicle,
            this.filterTimeWindow.filterGeofence,
            this.filterTimeWindow.fields,
          ]
          break
        case 'driving-behaviour':
          args = [
            this.filterDrivingBehaviour.filterVehicle,
            this.filterDrivingBehaviour.filterDriver,
            this.filterDrivingBehaviour.fields,
          ]
          break
        case 'driver-score':
          args = [
            this.filterDriverScore.filterDriver,
            this.filterDriverScore.filterGrade,
            this.filterDriverScore.fields,
          ]
          break
        case 'summary-vehicle-outside-geolocation':
          if (
            (this.filterSummaryVehicleOutsideGeolocation.filterGeofence === 0 ||
            this.filterSummaryVehicleOutsideGeolocation.filterGeofence.length === 0) ||
            this.filterSummaryVehicleOutsideGeolocation.filterVehicle.length === 0
          ) {
            this.alertFilter('vehicle_geolocation')
            return []
          }
          args = [
            this.filterSummaryVehicleOutsideGeolocation.filterGeofence,
            this.filterSummaryVehicleOutsideGeolocation.filterVehicle,
            this.filterSummaryVehicleOutsideGeolocation.fields,
          ]
          break

        case 'excessive-idle':
          if (
            this.report.key == 'excessive-idle' &&
            this.filterExcessiveIdle.filterVehicle.length == 0
          ) {
            this.alertFilter('vehicle')
            return []
          }
          args = [
            this.filterExcessiveIdle.filterVehicle,
            this.filterExcessiveIdle.filterDriver,
            this.filterExcessiveIdle.fields,
          ]
          break
        case 'daily-vehicle':
          if (
            this.report.key == 'daily-vehicle' &&
            this.filterDailyVehicle.filterVehicle.length == 0
          ) {
            this.alertFilter('vehicle')
            return []
          }
          args = [
            this.filterDailyVehicle.filterVehicle,
            this.filterDailyVehicle.filterDriver,
            this.filterDailyVehicle.fields,
          ]
          break
        case 'estimation-fuel-usage':
          if (
            this.report.key == 'estimation-fuel-usage' &&
            this.filterEstimationFuelUsage.filterVehicle.length == 0
          ) {
            this.alertFilter('vehicle')
            return []
          }
          args = [
            this.filterEstimationFuelUsage.filterVehicle,
            this.filterEstimationFuelUsage.fields,
          ]
          break
        default:
          return []
      }

      return args
    },

    openModal() {
      this.$bvModal.show(this.report.modal)
    },

    refreshState(ref, ...args) {
      this.openTableView = true
      this.reportPreview = true

      ref.openTable((this.report.label === 'Pemantauan Bulanan Kendaraan'?this.periodeMonth:this.periode), ...args)
    },

    downloadToExcel() {
      const validationPeriode = [
        'Pemantauan Bulanan Kendaraan',
        'Penilaian Pengemudi',
      ]
      const isIncluded = validationPeriode.includes(this.report.label);
      const isInvalidPeriode = !this.periode || !this.periode[0] || !this.periode[1];

      if ((isIncluded && !this.periodeMonth) || (!isIncluded && isInvalidPeriode)) {
        return Swal.fire({
          title: 'Gagal Pratinjau',
          text: 'Anda diharuskan memilih periode laporan terlebih dahulu.',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          confirmButtonText: 'Tutup',
        })
      }

      var args = this.generateFilter()
      if (args.length == 0) {
        return
      }

      this.$refs[this.report.table].downloadToExcel((this.report.label === 'Pemantauan Bulanan Kendaraan'?this.periodeMonth:this.periode), ...args)
    },

    downloadToPdf() {
      const validationPeriode = [
        'Pemantauan Bulanan Kendaraan',
        'Penilaian Pengemudi',
      ]
      const isIncluded = validationPeriode.includes(this.report.label);
      const isInvalidPeriode = !this.periode || !this.periode[0] || !this.periode[1];

      if ((isIncluded && !this.periodeMonth) || (!isIncluded && isInvalidPeriode)) {
        return Swal.fire({
          title: 'Gagal Pratinjau',
          text: 'Anda diharuskan memilih periode laporan terlebih dahulu.',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          confirmButtonText: 'Tutup',
        })
      }

      var args = this.generateFilter()
      if (args.length == 0) {
        return
      }

      this.$refs[this.report.table].downloadToPdf((this.report.label === 'Pemantauan Bulanan Kendaraan'?this.periodeMonth:this.periode), ...args)
    },

    downloadToGraph() {
      if (!this.periode || !this.periode[0] || !this.periode[1] || (!this.periodeMonth && this.report.key === 'driver-score')) {
        return Swal.fire({
          title: 'Gagal Pratinjau',
          text: 'Anda diharuskan memilih periode laporan terlebih dahulu.',
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          confirmButtonText: 'Tutup',
        })
      }

      var args = this.generateFilter()
      if (args.length == 0) {
        return
      }

      return this.$refs[this.report.table].downloadGraphToPdf(this.periode, ...args)
    },

    handlePicker(date) {
      var date1 = moment(date[0])
      var date2 = moment(date[1])

      var diff = date1.diff(date2, 'days')

      if (diff < 0) diff *= -1

      var maxDate = 7
      if (this.report.key == 'detail-history-vehicle') {
        maxDate = 3
      }

      if (diff > maxDate) {
        var dates = [
          moment(date1).format('YYYY-MM-DD'),
          moment(date1).add(maxDate, 'days').format('YYYY-MM-DD'),
        ]
        this.periode = dates
        return Swal.fire({
          title: 'Peringatan',
          text: `Periode laporan hanya bisa ${maxDate} hari`,
          imageUrl: require(`@/assets/images/alert-report-danger.png`),
          cancelButtonText: `Tutup`,
        })
      }
    },

    disabledRange: function (date) {
      return date <= this.pastDate || date >= this.futureEnd || date > new Date()
    },
    disabledRangeMonth: function (date) {
      let nextMonth = moment().add(1, 'month').startOf('month')
      return date >= nextMonth
    },

    pickDate(date) {
      var maxDate = 8
      const last_thirty_one_days_report =[
        'excessive-idle',
        'management-vehicle',
        'management-driver',
      ]
      if (this.report.key == 'detail-history-vehicle') {
        maxDate = 4
      } else if (this.report.key === 'driver-score') {
        this.periode = this.momentFirstAndEnd(date)
        return
      } else if (last_thirty_one_days_report.includes(this.report.key)) {
        maxDate = 31
      }

      this.pastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.futureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.futureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },

    changeReport() {
      this.openTableView = false
      this.reportPreview = false
      this.pastDate = moment().subtract(1, 'years')
      this.futureEnd = moment().add(1, 'years')
      this.$store.commit('report/changeGraphStatus', true)

      this.periode = null
      this.periodeMonth = null
    },

    alertFilter(type) {
      var text = ''
      if (type == 'vehicle') {
        text = 'Anda diharuskan memilih salah satu Plat Nomor pada Model Laporan'
      } else if (type == 'driver') {
        text = 'Anda diharuskan memilih salah satu Pengemudi pada Model Laporan'
      } else if (type == 'vehicle_garage') {
        text = 'Anda diharuskan memilih salah satu Plat Nomor dan Garasi pada Model Laporan'
      } else if (type == 'vehicle_geolocation') {
        text = 'Anda diharuskan memilih salah satu Plat Nomor dan Geolokasi pada Model Laporan'
      } else {
        text = 'Anda diharuskan memilih salah satu Plat Nomor atau Pengemudi pada Model Laporan'
      }

      return Swal.fire({
        title: 'Gagal Pratinjau',
        text: text,
        imageUrl: require(`@/assets/images/alert-report-danger.png`),
        cancelButtonText: `Tutup`,
        confirmButtonText: 'Buka Model Laporan',
        showCloseButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.openModal()
        }
      })
    },

    closePicker() {
      this.pastDate = moment().subtract(1, 'years')
      this.futureEnd = moment().add(1, 'years')
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <DownloadLoadingFloat :error-data="errorDownloadHistories"></DownloadLoadingFloat>
    <div class="mc-list-header" v-if="$store.state.config.mode == 'development'">
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button @click="$router.push({ name: 'Report Scheduler' })" variant="outline-primary" class="ms-3">
            Penjadwalan
            <i class="mc-fa icon-outline_calendar"></i>
          </b-button>
        </div>
      </div>
    </div>
    <section class="mc-report mt-3">
      <div class="card">
        <div class="card-body mc-card">
          <b-row>
            <b-col md="3">
              <b-form-group id="report-label" label="Pilih Laporan" label-for="report">
                <template #label>
                  <div class="">
                    <span>Pilih Laporan <i class="text-danger">*</i></span>
                  </div>
                </template>
                <multiselect v-model="report" :options="reportOptions" trackBy="key" label="label"
                  placeholder="Pilih Jenis Laporan" @input="changeReport"></multiselect>
              </b-form-group>
            </b-col>
            <b-col md="5" class="mc-report__favorit d-flex align-items-center">
              <b-form-group id="favorit-label" label="Favorit" label-for="favorit">
                <multiselect v-model="favorit" :options="favoritOptions" placeholder="Pilih Favorit" disabled>
                </multiselect>
              </b-form-group>
              <div v-if="report" v-b-tooltip.topright :title="report.key == 'detail-history-vehicle' &&
                filterDetailHistoryVehicle.filterVehicle.length == 0
                ? ''
                : ''
                " class="mc-input-info">
                <b-button variant="outline-primary" class="mc-btn-input d-inline-block ms-4" @click="openModal">
                  <i class="mc-fa icon-outline_settings"></i>
                </b-button>
                <span v-b-tooltip.hover.lefttop="'Diperlukan memilih salah satu kendaraan / pengemudi terlebih dahulu.'
                  ">
                  <i class="bx bx-info-circle"></i>
                </span>
              </div>
            </b-col>
            <b-col md="4">
              <b-button variant="outline-primary" class="mc-report-history__btn" @click="toDownloadHistory">
                <i class="mc-fa icon-outline_file-text"></i> Riwayat Unduhan Laporan
              </b-button>
            </b-col>
          </b-row>

          <b-card v-if="report" class="mc-report__interval">
            <div class="d-flex justify-content-between">
              <div class="mc-report__interval-filter">
                <b-row>
                  <b-col md="7">
                    <b-form-group id="favorit-label" label-for="periode">
                      <template #label>
                        <div class="d-flex justify-content-between align-items-center">
                          <label>Periode Laporan <i class="text-danger">*</i></label>
                          <span v-b-tooltip.topleft title="Periode laporan yang dapat diambil maksimal 6 Bulan">
                            <i class="icon-outline_info"></i>
                          </span>
                        </div>
                      </template>
                      <date-picker v-if="report.label === 'Detail Riwayat Kendaraan' ||
                        report.label === 'Riwayat Kendaraan' ||
                        report.label === 'Bahan Bakar' ||
                        report.label === 'Penggunaan Bahan Bakar (Tanpa Sensor)'
                        " type="datetime" v-model="periode" format="DD MMM YYYY HH:mm:ss" :shortcuts="makeShortcuts"
                        range-separator=" - " range value-type="YYYY-MM-DD HH:mm:ss" placeholder="Periode Laporan"
                        :disabled-date="disabledRange" @pick="pickDate" :confirm="true"
                        @close="closePicker"></date-picker>
                      <date-picker v-else-if="report.label === 'Pemantauan Bulanan Kendaraan' ||
                        report.label === 'Penilaian Pengemudi'
                        " type="month" v-model="periodeMonth" format="MMMM YYYY" value-type="YYYY-MM-DD"
                        placeholder="Periode Laporan" :disabled-date="disabledRangeMonth" @pick="pickDate"></date-picker>
                      <date-picker v-else type="date" v-model="periode" format="DD MMM YYYY" :shortcuts="makeShortcuts"
                        range-separator=" - " range value-type="YYYY-MM-DD" placeholder="Periode Laporan"
                        :disabled-date="disabledRange" @pick="pickDate"></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col md="5" v-if="report.key == 'detail-history-vehicle' || report.key == 'fuel'">
                    <b-form-group id="interval-label" label="Interval" label-for="interval">
                      <multiselect class="mt-3" v-model="interval" :options="intervalOptions" label="label" track-by="key"
                        placeholder="Interval"></multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="mc-report__interval-btn-group">
                <b-button variant="outline-primary" class="bg-white" @click="getPreviewReport">
                  <i class="mc-fa icon-outline_eye"></i> Pratinjau Laporan
                </b-button>
                <b-dropdown id="unduh-dropdown" right variant="primary" menu-class="dropdown-menu-end" class="ms-2">
                  <template v-slot:button-content>
                    Unduh <i class="mdi mdi-chevron-down ps-2"></i>
                  </template>
                  <b-dropdown-item href="#" @click="downloadToPdf"><i class="far fa-file-pdf"></i> Unduh Tabel
                    PDF</b-dropdown-item>
                  <b-dropdown-item href="#" @click="downloadToExcel"><i class="far fa-file-excel"></i> Unduh Tabel
                    Excel</b-dropdown-item>
                  <b-dropdown-item href="#" @click="downloadToGraph"
                    v-if="report.key == 'temperature' || report.key == 'fuel'"><i class="icon-fill_activity"></i> Unduh
                    Grafik PDF
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </b-card>
        </div>
      </div>

      <div class="mc-report-view">
        <h5 class="mc-report-view__title mb-3" v-if="reportPreview">Pratinjau Laporan</h5>
        <b-row class="text-muted mc-report-view__label-info" v-if="reportPreview && report.label !== 'Jendela Waktu'">
          <b-col md="2" v-if="report.label !== 'Jendela Waktu'">Jenis Laporan</b-col>
          <b-col :md="report.label === 'Detail Riwayat Kendaraan' || report.label === 'Riwayat Kendaraan'
            ? 4
            : 3
            " v-if="report.label !== 'Jendela Waktu'">Periode Laporan</b-col>
          <b-col md="2"
            v-if="report.label === 'Bahan Bakar' || report.label === 'Detail Riwayat Kendaraan'">Interval</b-col>
          <b-col md="2" v-if="report.label === 'Bahan Bakar' || report.label === 'Temperatur'">Plat Nomor</b-col>
        </b-row>
        <b-row class="mc-report-view__text-info" v-if="reportPreview && report.label !== 'Jendela Waktu'">
          <b-col md="2" v-if="report.label !== 'Jendela Waktu'">
            <span>{{ report.label }}</span>
          </b-col>
          <b-col :md="report.label === 'Detail Riwayat Kendaraan' || report.label === 'Riwayat Kendaraan'
            ? 4
            : 3
            " v-if="report.label !== 'Jendela Waktu'">
            <span v-if="report.label == 'Pemantauan Bulanan Kendaraan' || report.label == 'Penilaian Pengemudi'">{{ monthNameFilter }} {{ startDate }}</span>
            <span v-else>{{ startDate }} - {{ endDate }}</span>
          </b-col>
          <b-col md="2" v-if="report.label === 'Bahan Bakar' || report.label === 'Detail Riwayat Kendaraan'">
            <span>{{ delay }}</span>
          </b-col>
          <b-col md="2" v-if="report.label === 'Bahan Bakar' || report.label === 'Temperatur'">
            <span>{{ numPlate }}</span>
          </b-col>
        </b-row>

        <TimeWindowTable ref="timeWindowRef" v-if="report.label === 'Jendela Waktu'" />
        <b-card class="mt-3" :class="{ 'd-none': !openTableView }" v-if="report.label !== 'Jendela Waktu'">
          <FleetHistoryTable v-if="report.label === 'Riwayat Kendaraan'" ref="historyVehicleRef" />
          <GeolocationTable v-else-if="report.label === 'Geolokasi'" ref="geolocationRef" />
          <DrivingBehaviourTable v-else-if="report.label === 'Perilaku Mengemudi'" ref="drivingBehaviourRef" />
          <SummaryGeolocationTable v-else-if="report.label === 'Ringkasan Geolokasi'" ref="summaryGeolocationRef" />
          <WorkingHoursTable v-else-if="report.label === 'Jam Kerja'" />
          <DetailFleetHistoryTable v-if="report.label === 'Detail Riwayat Kendaraan'" ref="detailHistoryVehicleRef" />
          <DriverManagementTable v-else-if="report.label === 'Manajemen Pengemudi'" ref="managementDriverRef" />
          <FleetManagementTable v-else-if="report.label === 'Manajemen Kendaraan'" ref="managementVehicleRef" />
          <SummaryDayTable v-else-if="report.label === 'Ringkasan Harian Kendaraan'" ref="summaryDayRef" />
          <SummaryMonthVehicleTable v-else-if="report.label === 'Pemantauan Bulanan Kendaraan'"
            ref="summaryMonthVehicleRef" />
          <SummaryDayDriverTable v-else-if="report.label === 'Ringkasan Harian Pengemudi'" ref="summaryDayDriverRef" />
          <SummaryStoppedTable v-else-if="report.label === 'Waktu Berhenti'" ref="summaryStoppedRef" />
          <DoorTable v-else-if="report.label === 'Pintu'" ref="doorRef" />
          <TemperatureTable v-else-if="report.label === 'Temperatur'" ref="temperatureRef" />
          <FuelTable v-else-if="report.label === 'Bahan Bakar'" ref="fuelRef" />
          <DailyVehicleTable v-if="report.label === 'Pemantauan Harian Kendaraan'" ref="dailyVehicleMonitoringRef" />
          <DriverScoreTable v-else-if="report.label === 'Penilaian Pengemudi'" ref="driverScoreRef" />
          <SummaryVehicleOutsideGeofenceTable v-else-if="report.label === 'Ringkasan Kendaraan Keluar Geolokasi'" ref="summaryVehicleOutsideGeolocationRef" />
          <ExcessiveIdleTable v-else-if="report.label === 'Kendaraan Diam Berlebihan'" ref="excessiveIdleRef" />
          <EstimationFuelUsageTable v-else-if="report.label === 'Penggunaan Bahan Bakar (Tanpa Sensor)'" ref="estimationFuelUsageRef" />
        </b-card>
      </div>
    </section>

    <!-- Modal for filter Management Driver -->
    <modal-filter-report name="Manajemen Pengemudi" :fields="fieldsManagementDriver" v-model="filterManagementDriver">
    </modal-filter-report>

    <!-- Modal for filter Management Vehicle -->
    <modal-filter-report name="Manajemen Kendaraan" :fields="fieldsManagementVehicle" v-model="filterManagementVehicle">
    </modal-filter-report>

    <!-- Modal for filter History Vehicle -->
    <modal-filter-report name="Riwayat Kendaraan" :fields="fieldsHistoryVehicle" v-model="filterHistoryVehicle">
    </modal-filter-report>

    <!-- Modal for filter Detail History Vehicle -->
    <modal-filter-report name="Detail Riwayat Kendaraan" :fields="fieldsDetailHistoryVehicle"
      v-model="filterDetailHistoryVehicle" :is-filter-single="{ vehicle: true }"></modal-filter-report>

    <!-- Modal for filter Summary Day -->
    <modal-filter-report name="Ringkasan Harian Kendaraan" :fields="fieldsSummaryDay" v-model="filterSummaryDay">
    </modal-filter-report>

    <!-- Modal for filter Summary Month Vehicle -->
    <modal-filter-report name="Pemantauan Bulanan Kendaraan" :fields="fieldsSummaryMonthVehicle"
      v-model="filterSummaryMonthVehicle">
    </modal-filter-report>

    <!-- Modal for filter Summary Day Driver -->
    <modal-filter-report name="Ringkasan Harian Pengemudi" :fields="fieldsSummaryDayDriver"
      v-model="filterSummaryDayDriver"></modal-filter-report>

    <!-- Modal for filter Summary Stopped -->
    <modal-filter-report name="Waktu Berhenti" :fields="fieldsSummaryStopped" v-model="filterSummaryStopped">
    </modal-filter-report>

    <!-- Modal for filter Geolocation -->
    <modal-filter-report name="Geolokasi" :fields="fieldsGeolocation" v-model="filterGeolocation"></modal-filter-report>

    <!-- Modal for filter Summary Geolocation -->
    <modal-filter-report name="Ringkasan Geolokasi" :fields="fieldsSummaryGeolocation"
      v-model="filterSummaryGeolocation"></modal-filter-report>

    <!-- Modal for filter Door -->
    <modal-filter-report name="Pintu" :fields="fieldsDoor" v-model="filterDoor"></modal-filter-report>

    <!-- Modal for filter Temperature -->
    <modal-filter-report name="Temperatur" :fields="fieldsTemperature" v-model="filterTemperature"
      :is-filter-single="{ vehicle: true }"></modal-filter-report>

    <!-- Modal for filter Fuel -->
    <modal-filter-report name="Bahan Bakar" :fields="fieldsFuel" v-model="filterFuel"
      :is-filter-single="{ vehicle: true }"></modal-filter-report>

    <!-- Modal for filter Time Window -->
    <modal-filter-report name="Jendela Waktu" :fields="fieldsTimeWindow" v-model="filterTimeWindow"
      :is-filter-single="{ vehicle: true }"></modal-filter-report>

    <!-- Modal for filter Perilaku Mengemudi -->
    <modal-filter-report name="Perilaku Mengemudi" :fields="fieldsDrivingBehaviour"
      v-model="filterDrivingBehaviour"></modal-filter-report>

  <!-- Modal for filter Pemantauan Harian Kendaraan -->
    <modal-filter-report
      name="Pemantauan Harian Kendaraan"
      :fields="fieldsDailyVehicle"
      v-model="filterDailyVehicle"
    ></modal-filter-report>

    <!-- Modal for filter Excessive Idle -->
    <modal-filter-report name="Kendaraan Diam Berlebihan" :fields="fieldsExcessiveIdle"
      v-model="filterExcessiveIdle"></modal-filter-report>

    <!-- Modal for filter Driver Score -->
    <modal-filter-report name="Penilaian Pengemudi" :fields="fieldsDriverScore"
      v-model="filterDriverScore"></modal-filter-report>

    <!-- Modal for filter Vehicle Outside Geolocation -->
    <modal-filter-report name="Ringkasan Kendaraan Keluar Geolokasi" :fields="fieldsSummaryVehicleOutsideGeolocation"
      v-model="filterSummaryVehicleOutsideGeolocation"></modal-filter-report>
    
    <!-- Modal for filter Estimation Fuel Usage -->
    <modal-filter-report name="Penggunaan Bahan Bakar (Tanpa Sensor)" :fields="fieldsEstimationFuelUsage"
      v-model="filterEstimationFuelUsage"></modal-filter-report>

    <b-modal id="download-history-report" title="Riwayat Unduhan Laporan" class="mc-modal" header-bg-variant="primary"
      ref="modal-model-report" size="xl" centered scrollable ok-variant="outline-primary" ok-title="Tutup"
      title-class="text-white" header-close-variant="light" ok-only>
      <div id="tickets-table_filter" class="dataTables_filter text-end">
        <label class="d-inline-flex align-items-center mc-table-view__search ms-2">
          <i class="mc-fa fas fa-search"></i>
          <b-form-input v-model="historyFilter" type="search" :placeholder="$t('global.search') + '...'"
            class="ms-2"></b-form-input>
        </label>
      </div>

      <div class="table-responsive my-3 border border-1">
        <b-table :items="listDownloadHistories" :fields="historyFields" empty-table show-empty
          :busy="$apollo.queries.downloadHistory.loading" @filtered="onFilteredHistory"
          :empty-text="$t('global.emptyTable')" :empty-filtered-text="$t('global.emptyFilteredTable')"
          :per-page="historyPerPage" :filter="historyFilter" :current-page="historyCurrentPage" class="datatables"
          responsive="md">
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(downloadOn)="data">
            {{ momentDateShortMonth(data.item.downloadOn) }}
            <br />
            <span class="text-secondary">
              {{ momentTime(data.item.downloadOn) }}
            </span>
          </template>

          <template #cell(typeCode)="data">
            {{ data.item.typeCode.charAt(0) == 'T' ? 'Tabel' : 'Grafik' }}
            <br />
            <span class="text-secondary">
              {{ data.item.typeCode.charAt(1) == 'P' ? 'PDF' : 'Excel' }}
            </span>
          </template>

          <template #cell(periode)="data">
            {{ momentDateShortMonth(data.item.startDate) }} -
            {{ momentDateShortMonth(data.item.endDate) }}
          </template>

          <template #cell(action)="data">
            <a class="btn btn-outline-primary btn-sm" v-if="data.item.status == 'D'" :href="data.item.url"
              target="_blank"><i class="fas fa-download"></i> Unduh
            </a>
            <div v-else>
              <small>Mengunduh..</small>
            </div>
          </template>
        </b-table>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Menampilkan
              <b-form-select class="form-select form-select-sm" v-model="historyPerPage" size="sm"
                :options="historyPageOption">
              </b-form-select>
              entri.
              <p>
                Menampilkan
                <strong>{{
                  historyFilteredItems.length > 0
                  ? (historyCurrentPage - 1) * historyPerPage + 1
                  : 0
                }}</strong>
                -
                <strong>{{
                  Math.min(historyFilteredItems.length, historyCurrentPage * historyPerPage)
                }}</strong>&nbsp;dari&nbsp;<strong>{{ historyFilteredItems.length }}</strong>
              </p>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="historyCurrentPage" :total-rows="historyTotalRows" :per-page="historyPerPage">
              </b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
